import React, { useState } from 'react';
import { Card, CardContent, Box, Tabs, Tab } from '@mui/material';
import { useHistory } from 'react-router-dom';
import LiveMapRiderGrid from './LiveMapRiderGrid';
import AssignOrderGrid from './AssignOrderGrid';
import ReAssignOrderGrid from './ReAssignOrderGrid';
import RiderLatestLocationGrid from './RiderLatestLocationGrid';

const LIVE_MAP_TABS = [
    { label: 'Live MAP + GRID', key: 'livemap' },
    { label: 'Assign Order', key: 'assign' },
    { label: 'Re-Assign Order', key: 'reassign' },
    { label: 'Rider Latest Location', key: 'history' },
    { label: 'Order Management', key: 'ordermanagement' },
];

const LiveMapGrid = ({ selectedHubId }) => {
    const [activeTab, setActiveTab] = useState(0);
    const history = useHistory();

    const tabSx = {
        minHeight: 36,
        '& .MuiTab-root': {
            minHeight: 36,
            fontSize: 12,
            fontWeight: 'bold',
            padding: '6px 18px',
            textTransform: 'none',
            color: '#444',
            borderRight: '1px solid #d0d0d0',
        },
        '& .Mui-selected': {
            backgroundColor: '#1a2b4a',
            color: '#fff !important',
            borderRadius: '4px 4px 0 0',
        },
        '& .MuiTabs-indicator': { display: 'none' },
    };

    const renderContent = () => {

        switch (LIVE_MAP_TABS[activeTab].key) {
            case 'livemap':
                return (
                    <Box sx={{ minHeight: 200, width: '100%' }}>
                        <LiveMapRiderGrid selectedHubId={selectedHubId} />
                    </Box>
                );
            case 'assign':
                return (
                    <Box sx={{ minHeight: 200, width: '100%' }}>
                        <AssignOrderGrid selectedHubId={selectedHubId} />
                    </Box>
                );
            case 'reassign':
                return (
                    <Box sx={{ minHeight: 200, width: '100%' }}>
                        <ReAssignOrderGrid selectedHubId={selectedHubId} />
                    </Box>
                );
            case 'history':
                return (
                    <Box sx={{ minHeight: 200, width: '100%' }}>
                        <RiderLatestLocationGrid selectedHubId={selectedHubId} />
                    </Box>
                );
            default:
                return null;
        }
    };

    return (
        <Card variant="outlined" sx={{ width: '100%', mt: 2, borderRadius: 2, borderColor: '#d0d0d0' }}>
            <CardContent sx={{ padding: '12px !important' }}>
                {/* Tab strip */}
                <Box sx={{ borderBottom: '2px solid #32CA73', mb: 1.5 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(_, v) => {
                            if (LIVE_MAP_TABS[v].key === 'ordermanagement') {
                                history.push('/web_app/pnd_order/order_details');
                            } else {
                                setActiveTab(v);
                            }
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={tabSx}
                    >
                        {LIVE_MAP_TABS.map(t => <Tab key={t.key} label={t.label} />)}
                    </Tabs>
                </Box>
                {/* Tab content */}
                {renderContent()}
            </CardContent>
        </Card>
    );
};

export default LiveMapGrid;
